import { useState } from 'react';
import { useController } from 'react-hook-form';
import { Fields } from '../../../utils/Fields';
import classNames from 'classnames';
import Error from '../Error';
import { EyeOff, Eye } from 'react-feather';
import Label from '../Label';
import Instruction from '../Instruction';
import SubInstruction from '../SubInstruction';
var classes = {
    inputGroup: {
        base: 'flex items-center w-full rounded-md bg-white border transition-colors focus:border-2 focus:border-brand-dark',
        error: 'border-alert-danger focus:border-alert-danger',
        disabled: 'pointer-events-none bg-gray-100',
        size: {
            sm: 'px-2 py-2 gap-2 border-brand-01 text-sm overflow-hidden',
            md: 'px-4 py-[14px] border-gray-300 text-base',
        },
    },
    input: 'flex-1 focus:outline-none placeholder-gray-500',
};
var TextInput = function (_a) {
    var className = _a.className, label = _a.label, name = _a.name, placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? Fields.TEXT : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, control = _a.control, _d = _a.defaultValue, defaultValue = _d === void 0 ? '' : _d, _e = _a.required, required = _e === void 0 ? false : _e, instructions = _a.instructions, subInstructions = _a.subInstructions, icon = _a.icon, _f = _a.iconStart, iconStart = _f === void 0 ? false : _f, _g = _a.bigLabel, bigLabel = _g === void 0 ? false : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h;
    var _j = useController({ name: name, control: control, defaultValue: defaultValue }), field = _j.field, fieldState = _j.fieldState;
    var _k = useState(false), showPassword = _k[0], setShowPassword = _k[1];
    var _l = useState(false), showSubInstructions = _l[0], setShowSubInstructions = _l[1];
    var Icon = icon;
    return (<div className="flex w-full flex-col">
      {label && (<Label label={label} htmlFor={name} required={required} big={bigLabel} tooltip={!!subInstructions} onTooltipClick={function () { return setShowSubInstructions(true); }}/>)}
      {instructions && <Instruction instruction={instructions}/>}
      {subInstructions && (<SubInstruction instruction={subInstructions} open={showSubInstructions} close={function () { return setShowSubInstructions(false); }}/>)}
      <div className={classNames(classes.inputGroup.base, classes.inputGroup.size[size], fieldState.error && classes.inputGroup.error, disabled && classes.inputGroup.disabled, className)}>
        {icon && iconStart && (<Icon size={size === 'sm' ? 18 : 24} className="text-brand-01 flex-none"/>)}
        <input className={classNames(classes.input, disabled && classes.inputGroup.disabled)} placeholder={placeholder} type={showPassword ? 'text' : type} aria-invalid={fieldState.error ? 'true' : 'false'} {...field}/>
        {icon && !iconStart && (<Icon size={size === 'sm' ? 18 : 24} className="text-brand-01 flex-none"/>)}
        {type === 'password' && (<div className="cursor-pointer" onClick={function () { return setShowPassword(!showPassword); }}>
            {showPassword ? <EyeOff className="ml-2 h-6 w-6"/> : <Eye className="ml-2 h-6 w-6"/>}
          </div>)}
      </div>
      {fieldState.error && <Error message={fieldState.error.message}/>}
    </div>);
};
export default TextInput;
